module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_studio-7b5e4380329e7d1f21ab3d0f7c56daff.webp";